export default function displayAsTime(value: Date | null) {
    if (value === null) return "";

    return  value.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true // Use 12-hour format
  });
}